var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRewardsTrophy = function SvgRewardsTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F2F4FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RewardsTrophy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.333 17.365H35.88A2.013 2.013 0 0 0 34 16.03H22a2.013 2.013 0 0 0-1.88 1.334h-3.453a.667.667 0 0 0-.667.666v4.333a2.027 2.027 0 0 0 1.453 1.92l3.667 1.054a17.156 17.156 0 0 0 2.213 4 3.386 3.386 0 0 0 1.773 1.2l-.973 4.133H22.96a1.973 1.973 0 0 0-1.893 1.333l-1.027 3.08a.64.64 0 0 0 .32.804c.095.048.2.075.307.076h14.666a.693.693 0 0 0 .547-.28.64.64 0 0 0 .08-.6l-1.027-3.053a1.973 1.973 0 0 0-1.893-1.334h-1.174l-.973-4.133a3.386 3.386 0 0 0 1.773-1.2 17.16 17.16 0 0 0 2.214-4l3.666-1.053A2.027 2.027 0 0 0 40 22.391v-4.333a.666.666 0 0 0-.666-.693Zm-21.52 5.64a.667.667 0 0 1-.48-.64v-3.667H20v.666c.005 1.501.21 2.995.613 4.44l-2.8-.8Zm15.853 13.48.747 2.212H21.587l.746-2.213a.667.667 0 0 1 .627-.453h10.08a.667.667 0 0 1 .626.453Zm-8.16-1.788.934-4h3.12l.933 4h-4.986Zm6.094-6.133a1.987 1.987 0 0 1-1.6.8h-4a1.987 1.987 0 0 1-1.6-.8 15.466 15.466 0 0 1-3.067-9.2v-1.333a.667.667 0 0 1 .667-.666h12a.667.667 0 0 1 .666.666v1.334a15.467 15.467 0 0 1-3.066 9.2Zm7.066-6.2a.666.666 0 0 1-.48.64l-2.8.8c.403-1.445.609-2.939.614-4.44v-.666h2.666v3.666Z",
    fill: "#5C7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RewardsTrophy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 16)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgRewardsTrophy;